module.exports = __webpack_public_path__ + "img/menu-withdraw-white.d570ebec.svg";